import { IconUploadCloud } from "../IconType";

const GlowingIcon = ({ icon }: { icon: string }) => {
  const styleOuter = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FEF3F2",
    borderRadius: "50%",
    width: 56,
    minWidth: 56,
    height: 56,
    marginRight: 10,
  };

  const styleInner = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FEE4E2",
    borderRadius: "50%",
    width: 40,
    height: 40,
  };

  switch (icon) {
    case "trash":
      return (
        <div style={styleOuter}>
          <div style={styleInner}>{IconTrashRed}</div>
        </div>
      );
    case "upload":
      return (
        <div style={{ ...styleOuter, backgroundColor: "#F0F9FF" }}>
          <div style={{ ...styleInner, backgroundColor: "#E0F2FE" }}>
            {IconUploadCloud}
          </div>
        </div>
      );
    default:
      return null;
  }
};

export default GlowingIcon;

const IconTrashRed = (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 5V4.2C14 3.0799 14 2.51984 13.782 2.09202C13.5903 1.71569 13.2843 1.40973 12.908 1.21799C12.4802 1 11.9201 1 10.8 1H9.2C8.07989 1 7.51984 1 7.09202 1.21799C6.71569 1.40973 6.40973 1.71569 6.21799 2.09202C6 2.51984 6 3.0799 6 4.2V5M8 10.5V15.5M12 10.5V15.5M1 5H19M17 5V16.2C17 17.8802 17 18.7202 16.673 19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V5"
      stroke="#E74C3C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
